export class RouteHelper {
    static url(path) {
        return window.origin + (!path.startsWith("/") ? `/${path}` : path);
    }
}